module.exports = "<div class=\"q-pill q-pill-table q-marg-all-xs-at-md q-block {%- pillClass %}\">{%- data %}</div>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/filtersutil/html/statusPillsTemplate.html
// module id = 187
// module chunks = 1